import SelectBox from 'components/SelectBox';
import styles from './styles.module.scss';
import countriesData from '../../utils/countryData';
import FlagEmoji from './components/FlagEmoji';

function CountryDialCodeSelect({
  onChange,
  prefix,
  selectedCountryCode,
  className,
}) {
  const renderFlagIcon = (countryCode) => (
    <FlagEmoji className={styles.flag_emoji} countryCode={countryCode} />
  );

  const getFormatedDialCode = (dialCode) => `${prefix}${dialCode}`;

  const getCountryOptionTitle = (countryCode, countryName, dialCode) => {
    return (
      <div className={styles.country_select__option}>
        <div className='flex'>
          {renderFlagIcon(countryCode)}
          <span>{countryName}</span>
        </div>
        <span className={styles.dial_code}>
          {getFormatedDialCode(dialCode)}
        </span>
      </div>
    );
  };

  const getParsedCountry = (country) => {
    const [countryName, countryCode, dialCode] = country;

    return {
      value: countryCode,
      title: getCountryOptionTitle(countryCode, countryName, dialCode),
      countryName,
      dialCode,
    };
  };

  const selectOptions = countriesData.map((item) => getParsedCountry(item));

  const renderSelectedCountryHeadTitle = (option) => {
    return <div className='flex'>{renderFlagIcon(option.value)}</div>;
  };

  return (
    <div className={className}>
      <SelectBox
        value={selectedCountryCode}
        onChange={onChange}
        options={selectOptions}
        className={styles.country_select}
        searchKey='countryName'
        renderCustomHeadContent={renderSelectedCountryHeadTitle}
        returnForm='option'
        enableSearchBox={true}
        classNames={{
          head: styles.country_select_head,
          list: styles.country_select_list,
        }}
      />
    </div>
  );
}

CountryDialCodeSelect.defaultProps = {
  prefix: '+',
};

export default CountryDialCodeSelect;
